<div class="tools">
    <div class="drop-down" *ngIf="visible">
        <div class="menu">
            <a class="dropdown-link" href="javascript:;" (click)="openMeasureTools()">
                <span class="esri-icon-polyline"></span> Measurement
            </a>
            <a class="dropdown-link" href="javascript:;" (click)="openCalloutBox()">
                <span class="icon-ui-chat"></span> Callout Box
            </a>
            <a class="dropdown-link" href="javascript:;" (click)="openStreetView()">
                <span class="esri-icon-map-pin"></span> Street View
            </a>
            <a class="dropdown-link" href="javascript:;" (click)="openVideoLog()">
                <span class="esri-icon-play"></span> Video Log
            </a>
            <a class="dropdown-link" href="javascript:;" (click)="openPrint()">
                <span class="esri-icon-printer"></span> Print
            </a>
            <a class="dropdown-link" href="javascript:;" (click)="toggleTooltips()">
                <span class="esri-icon-comment"></span> Turn Tooltips {{ tooltipsTextOnOrOff }}
            </a>
        </div>
    </div>
</div>

<mc-window #measureToolsWindow title="Measure" width="600" top="65" right="100" is-draggable="true"
    (openChange)="onMeasureToolWindowOpenChange($event)">
    <div slot="content">
        <mc-tabs #tabs tabs='[{"name":"Distance", "active":true},{"name":"Area"},{"name":"Coordinates"}]'
            (tabChanged)="onMeasureToolsTabChanged($event)">
            <div slot="tab_1">
                <mc-distance #distance></mc-distance>
            </div>
            <div slot="tab_2">
                <mc-area #area></mc-area>
            </div>
            <div slot="tab_3">
                <mc-coordinates #coordinates></mc-coordinates>
            </div>
        </mc-tabs>
    </div>
</mc-window>

<mc-window id="calloutToolWindow" #calloutToolWindow is-resizable="true" title="Callout Box Tool" is-draggable="true"
    height="585" width="500" (openChange)="onCalloutBoxWindowOpenChange($event)">
    <mc-callout id="calloutTool" #calloutTool slot="content"></mc-callout>
</mc-window>

<mc-window id="streetViewWindow" #streetViewWindow title="Street View" top="20px" left="60px" width="600" height="500"
    is-draggable="true" is-resizable="true" (openChange)="onStreetViewWindowOpenChange($event)">
    <div slot="content" id="street-view-container">
        <mc-street-view id="streetView" lat="40.263001" long="-76.884089">
            <div class="widget-group" slot="widget-group">
                <mc-rms-select id="rmsSelect" slot="rms-select"></mc-rms-select>
                <mc-lat-long-select id="latLongSelect" slot="lat-long-select"></mc-lat-long-select>
            </div>
        </mc-street-view>
    </div>
</mc-window>

<mc-window id="videoLogWindow" #videoLogWindow title="Video Log Viewer" top="20px" left="60px" width="650" height="750"
    is-draggable="true" is-resizable="true" (openChange)="onVideoLogWindowOpenChange($event)">
    <div slot="content" id="videoLogViewerContainer" style="margin: -16px;">
        <div style="position: relative; height: 60%; margin-bottom: 30px;">
            <mc-video-log-viewer id="videoLog" lat="40.263001" long="-76.884089" [zoomOnPositionChange] = 'zoomOnPositionChange' #videoLog [markerSymbol]="markerSymbol"></mc-video-log-viewer>
            <mc-video-log-controller id="videoLogController"></mc-video-log-controller>
        </div>
        <mc-video-log-info id="video-log-info"></mc-video-log-info>
    </div>
</mc-window>
<mc-window #printWindow id="printWindow" title="Print Map" is-draggable="true" is-resizable="true" height="850px"
    width="475px" (openChange)="onPrintWindowOpenChange($event)">
    <mc-print #print slot="content"></mc-print>
</mc-window>